"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.formatDomainToSubdomainForDisplay = formatDomainToSubdomainForDisplay;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _IntegrationSetup = _interopRequireDefault(require("./IntegrationSetup"));

var _axios = _interopRequireDefault(require("axios"));

var _PanelItems = require("./components/PanelItems");

var _UninstallModal = _interopRequireDefault(require("./components/UninstallModal"));

var _Tabs = require("./components/thought-industries/Tabs");

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _interfaces = require("@insided/deprecated-control/integrations/interfaces");

var _constants = require("@insided/shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ThoughtIndustriesIntegration = /*#__PURE__*/function (_Integration) {
  (0, _inherits2.default)(ThoughtIndustriesIntegration, _Integration);

  var _super = _createSuper(ThoughtIndustriesIntegration);

  function ThoughtIndustriesIntegration(props) {
    var _props$enabledFederat, _props$apiKey, _props$enabledFederat2, _props$apiKey2;

    var _this;

    (0, _classCallCheck2.default)(this, ThoughtIndustriesIntegration);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveFederatedSearchSetting", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var errorMessage, _this$state, isFederatedSearchActive, filterQuery, successMessage, updatedState, _this$state$storedSta, _isFederatedSearchActive, _filterQuery;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                messageType: undefined,
                isSavingFederatedSearchSetting: true
              });

              errorMessage = "Something went wrong, setting can't be updated. Please try again.";
              _this$state = _this.state, isFederatedSearchActive = _this$state.isFederatedSearchActive, filterQuery = _this$state.filterQuery;
              _context.prev = 3;
              _context.next = 6;
              return _axios.default.post('/integration/thoughtindustries/saveFederatedSearchConf', {
                isActive: isFederatedSearchActive,
                filterQuery: filterQuery === null || filterQuery === void 0 ? void 0 : filterQuery.trim()
              });

            case 6:
              successMessage = 'Changes are saved successfully.';
              updatedState = _objectSpread(_objectSpread({}, _this.state.storedState), {}, {
                isFederatedSearchActive: isFederatedSearchActive,
                filterQuery: filterQuery
              });

              _this.setState({
                storedState: updatedState,
                message: successMessage,
                messageType: 'success',
                showFederatedSearchActionButtons: false,
                isSavingFederatedSearchSetting: false,
                federatedSearchInitialSyncCompleted: true
              });

              _publish.default.trackEvent('userevent', {
                type: "Thought Industries federated search ".concat(isFederatedSearchActive ? 'enabled' : 'disabled')
              });

              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              _this$state$storedSta = _this.state.storedState, _isFederatedSearchActive = _this$state$storedSta.isFederatedSearchActive, _filterQuery = _this$state$storedSta.filterQuery;

              _this.setState({
                messageType: 'error',
                message: errorMessage,
                showFederatedSearchActionButtons: false,
                isSavingFederatedSearchSetting: false,
                isFederatedSearchActive: _isFederatedSearchActive,
                filterQuery: _filterQuery,
                federatedSearchInitialSyncCompleted: false
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dismissMessage", function () {
      _this.setState({
        messageType: undefined,
        message: ''
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFilterChange", function (value) {
      _this.setState({
        showFederatedSearchActionButtons: true,
        showFilterWarning: !value.includes('status:'),
        filterQuery: value
      });
    });
    var subdomain = props.domain ? formatDomainToSubdomainForDisplay(props.domain) : '';

    _this.setState({
      isInstalled: !!(props.apiKey && props.domain),
      isFederatedSearchActive: (_props$enabledFederat = props.enabledFederatedSearch) !== null && _props$enabledFederat !== void 0 ? _props$enabledFederat : false,
      apiKey: (_props$apiKey = props.apiKey) !== null && _props$apiKey !== void 0 ? _props$apiKey : '',
      subdomain: subdomain !== null && subdomain !== void 0 ? subdomain : '',
      filterQuery: props.filterQuery === undefined ? 'status:published' : props.filterQuery,
      showFederatedSearchActionButtons: false,
      showFilterWarning: false,
      federatedSearchInitialSyncCompleted: false,
      storedState: {
        isFederatedSearchActive: (_props$enabledFederat2 = props.enabledFederatedSearch) !== null && _props$enabledFederat2 !== void 0 ? _props$enabledFederat2 : false,
        apiKey: (_props$apiKey2 = props.apiKey) !== null && _props$apiKey2 !== void 0 ? _props$apiKey2 : '',
        subdomain: subdomain !== null && subdomain !== void 0 ? subdomain : '',
        filterQuery: props.filterQuery === undefined ? 'status:published' : props.filterQuery
      }
    });

    _this.resetFederatedSearchSetting = _this.resetFederatedSearchSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveFederatedSearchSetting = _this.saveFederatedSearchSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.onInstall = _this.onInstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUninstall = _this.onUninstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetInstallationTab = _this.onResetInstallationTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetIntegrationTab = _this.onResetIntegrationTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetIntegrationPanelChanges = _this.resetIntegrationPanelChanges.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ThoughtIndustriesIntegration, [{
    key: "checkPanelHasUnsavedChanges",
    value: function checkPanelHasUnsavedChanges() {
      var _this$state2 = this.state,
          apiKey = _this$state2.apiKey,
          subdomain = _this$state2.subdomain,
          isFederatedSearchActive = _this$state2.isFederatedSearchActive,
          storedState = _this$state2.storedState;
      var hasApiTokenChanged = apiKey !== storedState.apiKey;
      var hasSubdomainChanged = subdomain !== storedState.subdomain;
      var hasFederatedSearchSettingChanged = isFederatedSearchActive !== storedState.isFederatedSearchActive;
      return hasApiTokenChanged || hasSubdomainChanged || hasFederatedSearchSettingChanged;
    }
  }, {
    key: "onInstall",
    value: function () {
      var _onInstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$state3, apiKey, subdomain, validatedFields, data, result, _result$data, _apiKey, domain, _subdomain, updatedStoredState, _error$response, _error$response$data, _this$state$storedSta2, _apiKey2, _subdomain2, errorResponse;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.resetMessages();
                _this$state3 = this.state, apiKey = _this$state3.apiKey, subdomain = _this$state3.subdomain;
                validatedFields = [];

                if (apiKey === '') {
                  validatedFields.push({
                    field: 'apiKey',
                    message: 'Please enter an API key.'
                  });
                }

                if (subdomain === '') {
                  validatedFields.push({
                    field: 'subdomain',
                    message: 'Please enter a subdomain.'
                  });
                }

                if (!this.isInputInvalid(validatedFields)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                data = {
                  apiKey: apiKey.trim(),
                  subdomain: subdomain.trim()
                };
                _context2.prev = 8;
                _context2.next = 11;
                return _axios.default.post('/integration/thoughtindustries/install', data);

              case 11:
                result = _context2.sent;
                _result$data = result.data, _apiKey = _result$data.apiKey, domain = _result$data.domain;
                _subdomain = formatDomainToSubdomainForDisplay(domain);
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.apiKey = _apiKey;
                updatedStoredState.subdomain = _subdomain;
                this.setState({
                  isInstalled: !!(_apiKey && _subdomain),
                  apiKey: _apiKey,
                  subdomain: _subdomain,
                  storedState: updatedStoredState,
                  message: 'All set! Thought Industries installed.',
                  messageType: 'success',
                  errorFields: [],
                  isSavingCredentials: false
                });

                _publish.default.trackEvent('userevent', {
                  type: 'Thought Industries app installed'
                });

                _context2.next = 26;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](8);
                _this$state$storedSta2 = this.state.storedState, _apiKey2 = _this$state$storedSta2.apiKey, _subdomain2 = _this$state$storedSta2.subdomain;
                errorResponse = (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.error;

                if (errorResponse !== null && errorResponse !== void 0 && errorResponse.toLowerCase().includes('base url')) {
                  this.setState({
                    errorFields: [{
                      field: 'subdomain',
                      message: _context2.t0.response.data.error
                    }],
                    isInstalled: false,
                    isSavingCredentials: false
                  });
                } else if (errorResponse !== null && errorResponse !== void 0 && errorResponse.toLowerCase().includes('api key')) {
                  this.setState({
                    errorFields: [{
                      field: 'apiKey',
                      message: _context2.t0.response.data.error
                    }],
                    isInstalled: false,
                    isSavingCredentials: false
                  });
                } else {
                  this.setState({
                    apiKey: _apiKey2,
                    subdomain: _subdomain2,
                    message: errorResponse || 'Sorry, something went wrong, please try again.',
                    messageType: 'error',
                    errorFields: [],
                    isSavingCredentials: false
                  });
                }

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 21]]);
      }));

      function onInstall() {
        return _onInstall.apply(this, arguments);
      }

      return onInstall;
    }()
  }, {
    key: "onResetIntegrationTab",
    value: function onResetIntegrationTab(activeTab) {
      this.resetFederatedSearchSetting();
      this.setState({
        activeTab: activeTab
      });
    }
  }, {
    key: "onResetInstallationTab",
    value: function onResetInstallationTab(activeTab) {
      this.setState({
        apiKey: '',
        subdomain: '',
        showUnsavedChangesModal: false,
        errorFields: [],
        activeTab: activeTab
      });
    }
  }, {
    key: "onUninstall",
    value: function () {
      var _onUninstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var successMessage, errorMessage, updatedStoredState;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                successMessage = "You've uninstalled Thought Industries.";
                errorMessage = 'Sorry, something went wrong, please try again.';
                _context3.prev = 3;
                _context3.next = 6;
                return _axios.default.put('/integration/thoughtindustries/uninstall');

              case 6:
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.isFederatedSearchActive = false;
                updatedStoredState.apiKey = '';
                updatedStoredState.subdomain = '';
                this.setState({
                  isInstalled: false,
                  apiKey: '',
                  subdomain: '',
                  isFederatedSearchActive: false,
                  storedState: updatedStoredState,
                  showUninstallModal: false,
                  messageType: 'success',
                  message: successMessage
                });
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](3);
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showUninstallModal: false
                });

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 13]]);
      }));

      function onUninstall() {
        return _onUninstall.apply(this, arguments);
      }

      return onUninstall;
    }()
  }, {
    key: "resetIntegrationPanelChanges",
    value: function resetIntegrationPanelChanges(activeTab) {
      this.setState({
        activePanel: undefined
      });
      var _this$state4 = this.state,
          isFederatedSearchActive = _this$state4.isFederatedSearchActive,
          storedState = _this$state4.storedState;

      if (isFederatedSearchActive !== storedState.isFederatedSearchActive) {
        this.resetFederatedSearchSetting();
      }

      if (this.state.selectedTab !== undefined && this.state.selectedTab !== this.state.activeTab) {
        this.setState({
          activeTab: activeTab
        });
      }
    }
  }, {
    key: "resetFederatedSearchSetting",
    value: function resetFederatedSearchSetting() {
      var _this$state5 = this.state,
          storedState = _this$state5.storedState,
          selectedPanel = _this$state5.selectedPanel;
      this.setState({
        isFederatedSearchActive: storedState.isFederatedSearchActive,
        filterQuery: storedState.filterQuery,
        showFederatedSearchActionButtons: false,
        showUnsavedChangesModal: false,
        activePanel: selectedPanel
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state6 = this.state,
          isInstalled = _this$state6.isInstalled,
          messageType = _this$state6.messageType,
          message = _this$state6.message,
          activeTab = _this$state6.activeTab,
          showUninstallModal = _this$state6.showUninstallModal,
          apiKey = _this$state6.apiKey,
          subdomain = _this$state6.subdomain,
          errorFields = _this$state6.errorFields,
          showUnsavedChangesModal = _this$state6.showUnsavedChangesModal,
          isSavingCredentials = _this$state6.isSavingCredentials,
          isFederatedSearchActive = _this$state6.isFederatedSearchActive,
          showFederatedSearchActionButtons = _this$state6.showFederatedSearchActionButtons,
          showFilterWarning = _this$state6.showFilterWarning,
          isSavingFederatedSearchSetting = _this$state6.isSavingFederatedSearchSetting,
          filterQuery = _this$state6.filterQuery,
          storedState = _this$state6.storedState,
          activePanel = _this$state6.activePanel,
          federatedSearchInitialSyncCompleted = _this$state6.federatedSearchInitialSyncCompleted;
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var enabledIntegrationCount = this.state.storedState.isFederatedSearchActive ? 1 : 0;
      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "Thought Industries",
        appLogoName: "thought-industries-l",
        appContainerBackgroundColor: "#233746",
        dismissMessage: this.dismissMessage,
        messageType: messageType,
        message: message,
        installButton: isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: function onClickUninstallButton() {
            return _this2.onClickUninstallButton();
          }
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install now",
          className: "installation__button_cta",
          onClick: function onClick() {
            return _this2.setActiveTab(1);
          }
        }),
        description: (0, _preact.h)(OverviewDescriptionText, null),
        tabTitles: ['Integration', 'Installation'],
        activeTab: activeTab,
        onClickTab: function onClickTab(selectedTab) {
          return _this2.setActiveTab(selectedTab);
        },
        tabContents: [(0, _preact.h)(_Tabs.IntegrationTab, {
          key: "integrationTab",
          activePanel: activePanel,
          isInstalled: isInstalled,
          isFederatedSearchActive: isFederatedSearchActive,
          showActionButtons: showFederatedSearchActionButtons,
          onSave: this.saveFederatedSearchSetting,
          onCancel: function onCancel() {
            return _this2.resetFederatedSearchSetting();
          },
          onSettingChanged: function onSettingChanged() {
            return _this2.onFederatedSearchSettingChanged(!isFederatedSearchActive);
          },
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          showFilterWarning: showFilterWarning,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this2.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this2.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this2.onResetIntegrationTab(1);
          },
          isSavingFederatedSearchSetting: isSavingFederatedSearchSetting,
          onClickPanelCallback: function onClickPanelCallback(selectedPanel) {
            return _this2.setSelectedPanel(selectedPanel);
          },
          storedState: storedState,
          filterQuery: filterQuery,
          onFilterChange: this.onFilterChange,
          federatedSearchInitialSyncCompleted: federatedSearchInitialSyncCompleted
        }), (0, _preact.h)(_Tabs.InstallationTab, {
          key: "installationTab",
          apiKey: apiKey,
          subdomain: subdomain,
          isInstalled: isInstalled,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this2.onInstall();

                  case 2:
                    return _context4.abrupt("return", _context4.sent);

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          })),
          onCancel: function onCancel() {
            return _this2.onResetInstallationTab(1);
          },
          onApiKeyChangeCallback: function onApiKeyChangeCallback(value) {
            return _this2.setState({
              apiKey: value
            });
          },
          onApiKeyClickCallback: function onApiKeyClickCallback() {
            _this2.removeValidationErrorFromInputField('apiKey');
          },
          onSubdomainChangeCallback: function onSubdomainChangeCallback(value) {
            return _this2.setState({
              subdomain: value
            });
          },
          onSubdomainClickCallback: function onSubdomainClickCallback() {
            return _this2.removeValidationErrorFromInputField('subdomain');
          },
          onClickManage: function onClickManage() {
            return _this2.setActiveTab(0);
          },
          onClickUninstall: function onClickUninstall() {
            return _this2.onClickUninstallButton();
          },
          errorFields: errorFields,
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this2.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this2.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this2.onResetInstallationTab(0);
          },
          isSavingCredentials: isSavingCredentials
        })],
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: "Thought Industries",
          onUninstall: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
            return _regenerator.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this2.onUninstall();

                  case 2:
                    return _context5.abrupt("return", _context5.sent);

                  case 3:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          })),
          showUninstallModal: showUninstallModal,
          closeUninstallModal: function closeUninstallModal() {
            return _this2.closeUninstallModal();
          },
          enabledIntegrationCount: enabledIntegrationCount
        })
      });
    }
  }]);
  return ThoughtIndustriesIntegration;
}(_interfaces.Integration);

var OverviewDescriptionText = function OverviewDescriptionText() {
  return (0, _preact.h)("div", null, "Thought Industries helps organizations of all sizes build successful, long-term customer and partner relationships through engaging learning experiences tailored to the individual, team, industry, geography or subject matter.", (0, _preact.h)("div", {
    className: "description-details"
  }, "With Gainsight ", _constants.PLATFORM_BRAND_NAME_POSSESSIVE_FORM, " Thought Industries integration, you can easily setup a federated search. Your customers can seamlessly search for Thought Industries courses through your", ' ', _constants.PLATFORM_BRAND_NAME, "."));
};

function formatDomainToSubdomainForDisplay(domain) {
  if (domain.includes('.eu.')) {
    return domain.split('.eu.')[0] + '.eu';
  }

  return domain.split('.')[0];
}

var _default = ThoughtIndustriesIntegration;
exports.default = _default;